<script lang="ts" setup>
import { type PropType } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import useSideNav from '@helm/composables/sideNav'
import type { SideNavLocation } from '@helm/types/sideNav'
import SmartIcon from '@helm/components/SmartIcon.vue'

const props = defineProps({
    menu: {
        type: String as PropType<SideNavLocation>,
        required: true
    }
})

const { sideNav, isCurrentRoute, getRouteKey } = useSideNav(props.menu)

const listClasses = (itemRoute: RouteLocationRaw) => {
    const classList = [`relative`]

    if (isCurrentRoute(itemRoute)) {
        classList.push(
            `before:absolute`,
            `before:top-0`,
            `before:left-0`,
            `before:h-full`,
            `before:w-1.5`,
            `before:bg-primary`,
            `before:rounded-r-[20px]`
        )
    }

    return classList
}

const linkClasses = (itemRoute: RouteLocationRaw) => {
    const classList = [
        `flex`,
        `items-center`,
        `gap-4`,
        `h-[38px]`,
        `!px-[22px]`,
        `text-primary`,
        `font-bold`,
        `transition-opacity`
    ]

    if (isCurrentRoute(itemRoute)) {
        classList.push(`pointer-events-none`)
    } else {
        classList.push(`opacity-40`, `hover:opacity-100`)
    }

    return classList
}
</script>

<template>
    <div class="relative hidden shrink-0 grow-0 bg-secondary-50 !pt-[30px] lg:block lg:w-[260px] print:hidden">
        <ul class="flex flex-col gap-4">
            <li
                v-for="item in sideNav"
                :key="getRouteKey(item.route)"
                :class="listClasses(item.route)">
                <a
                    v-if="item.target && typeof item.route === `string`"
                    :href="item.route"
                    :target="item.target"
                    :class="linkClasses">
                    <SmartIcon
                        :icon="item.icon"
                        class="size-6 shrink-0" />
                    <span>
                        {{ item.label }}
                    </span>
                </a>
                <router-link
                    v-else
                    :to="item.route"
                    :class="linkClasses(item.route)">
                    <SmartIcon
                        v-if="item.icon"
                        :icon="item.icon"
                        class="size-6 shrink-0" />
                    <span>
                        {{ item.label }}
                    </span>
                </router-link>
            </li>
        </ul>
    </div>
</template>
